import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import MainContainer from './MainContainer';
import React from 'react';
import PageBase from './PageBase';

const appTheme = createTheme({
    typography: {
        fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: '8px',
                    fontWeight: 500,
                    fontFamily: "'Inter', system-ui, sans-serif",
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    fontFamily: "'Inter', system-ui, sans-serif",
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: '12px',
                },
            },
        },
    },
});

const InstashellApp = ({ instashellSetup }) => {

    const generateUnshelledRoutes = () => {
        const unshelledRoutes = [];
        instashellSetup.unshelledRoutesArr.forEach(route => {
            unshelledRoutes.push(
                <Route
                    key={route.path}
                    path={route.path}
                    render={(props) => route.targetPageComponent(props)}
                    exact
                />
            );
        });
        return unshelledRoutes;
    };

    const generateShelledRoutes = () => {
        const shelledRoutes = [];
        instashellSetup.shelledRoutesArr.forEach(route => {
            shelledRoutes.push(
                <Route
                    key={route.path}
                    path={route.path}
                    render={(props) => (
                        <PageBase pageTitle={route.pageTitle} hasBackButton={route.hasBackButton}>
                            {route.targetPageComponent(props)}
                        </PageBase>
                    )}
                    exact
                />
            );
        });
        return shelledRoutes;
    };

    return (
        <ThemeProvider theme={appTheme}>
            <CssBaseline />
            <Router>
                <Switch>
                    {generateUnshelledRoutes()}
                    <MainContainer instashellSetup={instashellSetup}>
                        {generateShelledRoutes()}
                    </MainContainer>
                </Switch>
            </Router>
        </ThemeProvider>
    );
};

export default InstashellApp;
